import React from 'react';
import styles from './CardSelector.module.scss';
import HelpButton from '../../atoms/HelpButton/HelpButton';

export type CardOption = {
  value: string;
  label: string;
  priceInfo: string;
  description: string;
  image?: string;
  disabled?: boolean;
  disabledMessage?: string;
};

export type CardSelectorProps = {
  title: string;
  options: CardOption[];
  selectedValue: string;
  onChange: (value: string) => void;
  showQuestionIcon?: boolean;
  helpText?: string;
};

const CardSelector: React.FC<CardSelectorProps> = ({
  title,
  options,
  selectedValue,
  onChange,
  showQuestionIcon = true,
  helpText,
}) => {
  return (
    <div className={styles.cardSelector}>
      <div className={styles.titleContainer}>
        <h4 className={styles.title}>{title}</h4>
        {showQuestionIcon && helpText && (
          <HelpButton helpText={helpText} />
        )}
      </div>
      <div className={styles.optionsContainer}>
        {options.map((option) => (
          <label
            key={option.value}
            className={`${styles.optionCard} ${option.disabled ? styles.disabled : ''}`}
            aria-disabled={option.disabled}
          >
            <input
              type="radio"
              name={title}
              value={option.value}
              checked={selectedValue === option.value}
              onChange={() => !option.disabled && onChange(option.value)}
              className={styles.radioInput}
              disabled={option.disabled}
            />
            <span className={styles.customRadio} />
            {option.image && <img src={option.image} alt="" className={styles.optionImage} />}
            <div className={styles.optionDetails}>
              <div className={styles.optionHeader}>
                <span className={styles.optionLabel}>{option.label}</span>
                <span className={styles.priceInfo}>{option.priceInfo}</span>
              </div>
              <p className={styles.optionDescription}>{option.description}</p>
              {/* 非活性メッセージ表示 */}
              {option.disabled && option.disabledMessage && (
                <p className={styles.disabledMessage}>{option.disabledMessage}</p>
              )}
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CardSelector; 